export const SELECTION_COLUMN_ID = 'selection';

export const MISSING_LINE_ITEM_ERROR_MESSAGE = 'Missing Line Item';

export const MISSING_LINE_ITEM_DURING_PACING_TYPE_UPDATE_DESCRIPTION =
  'Cannot update pacing type because Ad does not have a Line Item';
